export enum PaymentMethod {
  CASH = "pm111111-1111-1111-1111-111111111111",
  CARD = "pm222222-2222-2222-2222-222222222222",
  CHEQUE = "pm333333-3333-3333-3333-333333333333",
  BANK_TRANSFER = "pm444444-4444-4444-4444-444444444444",
  CREDIT = "pm555555-5555-5555-5555-555555555555",
}

export const PaymentMethodInfo = {
  [PaymentMethod.CASH]: { code: "cash", name: "Cash" },
  [PaymentMethod.CARD]: { code: "card", name: "Card" },
  [PaymentMethod.CHEQUE]: { code: "cheque", name: "Cheque" },
  [PaymentMethod.BANK_TRANSFER]: {
    code: "bank_transfer",
    name: "Bank Transfer",
  },
  [PaymentMethod.CREDIT]: { code: "credit", name: "Credit" },
} as const;

export const getPaymentMethodCode = (value: PaymentMethod): string =>
  PaymentMethodInfo[value].code;
export const getPaymentMethodName = (value: PaymentMethod): string =>
  PaymentMethodInfo[value].name;
